export default "__VITE_ASSET__6863bfaa__"